module.exports = __webpack_public_path__ + "media/src/img/payment/omoney-8749879be378bcf9e6233746766bc1c5.png";